/* eslint-disable import/first */
import React, { useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { autoPlay } from 'react-swipeable-views-utils';
const { useSelector } = Redux;
import { useIntl } from 'react-intl';
import compact from 'lodash/compact';
import SwipeableViews from 'react-swipeable-views';
import { useNavigate, useLocation, Link } from '@reach/router';
import { generateCategoryRoute, generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import { addDesktopRepository } from 'spwa-ui-library/esm/utils/helper';
const { selectCategoryEntities } = Slices.categorySlice;
const { selectProductEntities, fetchProductsByCategoryId, getProductInfo } = Slices.productSlice;
const { getClusterId, selectCountryValidations } = Slices.configSlice;
// const { selectHomeBaseURL } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDesktop } = Slices.appSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { addProductToCustomize } = Slices.tempCartSlice;

import 'react-lazy-load-image-component/src/effects/blur.css';
import css from './index.module.scss';
import classnames from 'classnames';
// import banner from './images/banner.jpg';
// eslint:fix banner is defined but never used
import {
  promoClickGA,
  promoViewGA,
  trackingPromotionClickGA,
  trackingPromotionViewedGA,
  trackingPromotionClickEventGA,
} from 'spwa-ui-library/esm/utils/helperGA';

const { useDispatch } = Redux;
let scrollTimerInstance = null;
export default function HeroBanner({ widgetData, viewAllMenu }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const clusterId = useSelector(getClusterId);
  const location = useLocation();
  const address = useSelector(selectDefaultAddress);
  const isDesktop = useSelector(selectDesktop);
  // const imgBaseUrl = useSelector(selectHomeBaseURL);
  const categories = useSelector(selectCategoryEntities);
  // eslint:fix isDesktop is assigned but never used
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  // eslint:fix country is assigned but never used
  const products = useSelector(selectProductEntities);
  const navigate = useNavigate();
  const [currentSlider, setCurrentSlider] = React.useState(0);
  const autoScrollInterval = countryValidations.bannerTimeInterval * 800;

  // const [newSortedImg, setNewSortedImg] = React.useState([]);
  // const [loaded, setLoaded] = React.useState(false);
  const AutoPlaySwipeableViews = isDesktop ? autoPlay(SwipeableViews) : SwipeableViews;
  const axis = intl.locale === 'ar' ? 'x-reverse' : 'x';

  let sortedArray = widgetData.media;
  if (sortedArray) {
    sortedArray = sortedArray.slice().sort((x, y) => x.sequence - y.sequence);
  }

  const handleSliderChange = (index) => {
    setCurrentSlider(index);
    clearTimeout(scrollTimerInstance);
    if (countryValidations.autoBanner && autoScrollInterval > 1) {
      scrollTimerInstance = setTimeout(() => {
        let nextSlideIndex = 0;
        if (window.location.pathname === '/en/home') {
          nextSlideIndex = index === sortedArray.length - 1 ? 0 : index + 1;
        } else {
          nextSlideIndex = index;
        }
        handleSliderChange(nextSlideIndex);
      }, autoScrollInterval);
    }
  };

  useEffect(() => {
    if (!scrollTimerInstance) {
      handleSliderChange(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // this code we are using to remove banner which have broken images
  // useEffect(() => {
  //   sortedArray.map((itm) => {
  //     const check = new Image();
  //     check.src = `${imgBaseUrl}${itm.mediaUrl}`;
  //     check.onload = function () {
  //       loadImages(itm);
  //       // console.log(itm);
  //     };
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // let newSortedImg = [];
  // const loadImages = (img) => {
  //   // newSortedImg.push(img.sequence);
  //   setNewSortedImg((prev) => [...prev, img]);
  // };

  useEffect(() => {
    promoViewGA(widgetData.media);
    // debugger;
    trackingPromotionViewedGA(widgetData.media);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSlide = React.useCallback(
    (id) => () => {
      setCurrentSlider(id);
    },
    []
  );

  const handleBannerClick = ({ media, path, type, category, productId }) => (e) => {
    if (path) {
      e.preventDefault();
      e.stopPropagation();
      promoClickGA(media);
      trackingPromotionClickGA(media);
      const productInfo = products[productId];
      trackingPromotionClickEventGA(media, productInfo);
      if (type === 'product') {
        dispatch(
          getProductInfo({
            id: productId,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: category?.id || category,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          const productObj = resp?.payload;
          console.log(`resp?.payload ==> `, resp?.payload);
          dispatch(
            addProductToCustomize({
              productType: productObj?.bundleTypeId,
              updatedOn: new Date().getTime(),
              mainProductId: productObj?.id,
              data: { ...resp.payload, category: category?.id || category, noIncrement: true },
            })
          );
          navigate(path, {
            state: {
              retUrl: `/${intl.locale}/home/`,
              oldLocation: location,
              description: intl.formatMessage({ id: 'customize_your_meals' }),
            },
          });
        });
      } else {
        dispatch(
          fetchProductsByCategoryId({
            id: category,
            cluster: clusterId,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        );
        navigate(path, {
          state: {
            retUrl: `/${intl.locale}/home/`,
          },
        });
      }
    } else {
      viewAllMenu(e);
    }
  };
  let filteredArr = sortedArray.length && sortedArray.filter((item) => item.mediaUrl !== '');

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const checkIfInsideTiming = (startTime, endTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');
    let end = endTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(end[0]),
      parseInt(end[1]),
      0
    );

    return startDate.getTime() <= date.getTime() && date.getTime() <= endDate.getTime();
  };

  const defaultTimings = { from: '00:00', to: '00:00' };
  const currentDayOfWeek =
    days[
      new Date(
        new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
      ).getDay()
    ];

  const checkIfAvil = (displayDays) => {
    let isItemAvailable = true;
    if (Object.values(displayDays || {}).length === 0) {
      isItemAvailable = true;
    } else {
      // debugger;
      const dayTimings = displayDays?.[currentDayOfWeek] || defaultTimings;
      let dealFallsInTiming = false;

      for (let timing of Array.isArray(dayTimings)
        ? dayTimings
        : Object.keys(dayTimings || {}).length > 0
        ? [dayTimings]
        : []) {
        if (checkIfInsideTiming(timing?.from, timing?.to)) {
          dealFallsInTiming = true;
          break;
        }
      }
      if (!dealFallsInTiming) {
        isItemAvailable = false;
      }
    }
    return isItemAvailable;
  };

  try {
    filteredArr = compact(
      filteredArr.filter((banner, id) => {
        return checkIfAvil(banner.displayDay);
      })
    );
  } catch (error) {
    console.error(error);
  }
  if (!filteredArr.length) {
    return null;
  }

  return (
    <div className={css.root}>
      <SwipeableViews
        animateTransitions={true}
        // enableMouseEvents={false}
        slideClassName={`${css.bannerItemContainer}${!isDesktop ? ` ${css.noDesktop}` : ''}`}
        className={css.container}
        index={currentSlider}
        onChangeIndex={handleSliderChange}
        axis={axis}
      >
        {filteredArr.map((media, idx) => {
          let category = categories[media.action.id];
          let targetPath = generateCategoryRoute({ category, locale: intl.locale });
          const product = products[media.action.id];
          if (!category && product) {
            targetPath = generateProductRoute({
              product,
              category:
                categories[product?.categories?.[0]] || categories[media.action.category_id],
              locale: intl.locale,
            });
          }
          const mediaURL = isDesktop ? addDesktopRepository(media.mediaUrl) : media.mediaUrl;
          if (
            (product?.typeId == 'bundle' || product?.bundleTypeId == 'bundle') &&
            product?.typeId != 'simple'
          ) {
            targetPath = targetPath + '/bundle';
          }

          if (media.mediaType === 'video') {
            return (
              <Link
                to={targetPath || ''}
                className={css.bannerItem}
                key={`${media.mediaType}-${media.mediaUrl}-${idx}`}
                onClick={handleBannerClick({
                  media: media,
                  path: targetPath || '',
                  type: media.action.type,
                  category: media.action.category_id,
                  productId: product?.id,
                })}
              >
                <img src={`${media.mediaUrl}`} alt={media.title} effect="blur" />
                {/* <video
                  width="300"
                  controls="false"
                  playsinline
                  muted="true"
                  preload="auto"
                  autoplay="true"
                  data-object-fit="cover"
                  alt={media.title}
                  poster={`${imgBaseUrl}${media.mediaUrl}`}
                >
                  <source
                    src={`${imgBaseUrl}${media.videoUrl}`}
                    type='video/mp4;codecs="avc1.4D401E, mp4a.40.2"'
                  />
                </video> */}
              </Link>
            );
          } else {
            return (
              <Link
                to={targetPath || ''}
                className={css.bannerItem}
                key={`${media.mediaType}-${media.mediaUrl}-${idx}`}
                onClick={handleBannerClick({
                  media: media,
                  path: targetPath || '',
                  type: media.action.type,
                  category: media.action.category_id,
                  productId: product?.id,
                })}
              >
                {/* TODO: NEED TO REMOVE DEFAULT MEDIA URL CODE */}
                <img src={`${mediaURL}`} alt={media.title} effect="blur" />
              </Link>
            );
          }
        })}
      </SwipeableViews>
      <div className={css.pagination}>
        {filteredArr.map((media, i) => {
          const checked = currentSlider === i ? true : false;
          return (
            <div
              className={classnames(css.point, { [css.currentPoint]: checked })}
              onClick={handleSlide(i)}
            ></div>
          );
        })}
      </div>
    </div>
  );
}
